/* eslint-disable @typescript-eslint/no-unused-vars */

import { Modal, Spin } from "antd";
import Styles from "../css/vehicleModals.module.scss";
import Caution from "../../../../assets/cautionicon.svg";
import { useAppSelector } from "customHooks/useAppSelector";
import moment from "moment";
import { formatAmount } from "utils/currency";
import Back from "../../../../assets/back-icon.svg";
import { useEffect, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";

const MerchantConfirmationVehicleModal = (props: any) => {
  const [loading, setLoading] = useState(false);
  const {
    loadingApi,
    repaymentResponseData,
    isInspection,
    equityValue,
    tenor,
    vehicleSingleData,
  } = props;
  const vehicleData = useAppSelector(
    (state) => state?.vehicleFinance?.vehicleInfo
  );
  const isLoading = useAppSelector((state) => state?.vehicleFinance?.isLoading);
  ;
  return (
    <div>
      <Modal
        title="Basic Modal"
        centered
        destroyOnClose={true}
        width={500}
        open={props.isModalOpen}
        onOk={props.handleOk}
        // onCancel={props.handleCancel}
        className={Styles.customModal}
        // className="summaryParentxx"
      >
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "1em",
              paddingTop: "1em",
              paddingBottom: "1em",
            }}
          >
            <Spin
              indicator={
                <LoadingOutlined
                  style={{ fontSize: 40, color: "black" }}
                  spin
                />
              }
            />
          </div>
        ) : (
          <div>
            <div
              className={Styles.modalContentVerification}
              style={{ paddingBottom: "0em" }}
            >
              <div style={{ cursor: "pointer" }}>
                <img
                  onClick={props.goBackToEquity}
                  src={Back}
                  className={Styles.backIcon}
                  alt="back"
                />
              </div>
              <div
                style={{ textAlign: "center", paddingTop: "0em" }}
                className={Styles.title}
              >
                Vehicle Finance Loan Summary
              </div>
              <div
                className={Styles.merchantBox}
                style={{
                  background: "white",
                  height: "70vh",
                  overflow: "scroll",
                }}
              >
                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>
                    Car Inspection location
                  </div>
                  <div className={Styles.merchantHalfRight}>
                    {vehicleData?.Meta?.CarDetails?.LocationAddress}
                  </div>
                </div>

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Dealership Name</div>
                  <div className={Styles.merchantHalfRight}>
                    {vehicleData?.MerchantName}
                  </div>
                </div>

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>
                    Contact Phone Number
                  </div>
                  <div className={Styles.merchantHalfRight}>
                    {vehicleData?.Meta?.CarDetails?.ContactNumber}
                  </div>
                </div>

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Car Value</div>
                  <div className={Styles.merchantHalfRight}>
                    {formatAmount(vehicleData?.Amount)}
                  </div>
                </div>

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Request Date</div>
                  <div className={Styles.merchantHalfRight}>
                    {moment(vehicleData?.CreatedOn).format("Do-MMM-YYYY")}
                  </div>
                </div>

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Expiry Date</div>
                  <div className={Styles.merchantHalfRight}>
                    {moment(vehicleData?.ExpiredOn).format("Do-MMM-YYYY")}
                  </div>
                </div>

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Loan Amount</div>
                  <div className={Styles.merchantHalfRight}>
                    {formatAmount(vehicleData?.LoanAmount)}
                  </div>
                </div>

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Monthly Repayment</div>
                  <div className={Styles.merchantHalfRight}>
                    {formatAmount(vehicleData?.MonthlyRepayment)}
                  </div>
                </div>

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Tenor</div>
                  <div className={Styles.merchantHalfRight}>
                    {tenor || vehicleData?.Tenor} Month(s)
                  </div>
                </div>

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>
                    Equity Contribution Entered
                  </div>
                  <div className={Styles.merchantHalfRight}>
                    {formatAmount(equityValue || vehicleData?.EquityContribution)}
                  </div>
                </div>

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>
                    Comprehensive Motor Vehicle Insurance
                  </div>
                  <div className={Styles.merchantHalfRight}>
                    {formatAmount(vehicleData.VehicleInsurance)}
                  </div>
                </div>

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>
                    Credit Life Insurance
                  </div>
                  <div className={Styles.merchantHalfRight}>
                    {formatAmount(vehicleData?.CreditLifeInsurance)}
                  </div>
                </div>

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Management Fee</div>
                  <div className={Styles.merchantHalfRight}>
                    {formatAmount(vehicleData?.ManagementFee)}
                  </div>
                </div>
                <div
                  className={Styles.borderLineTwo}
                  style={{ margin: "0em" }}
                />
                <div className={Styles.rowContent}>
                  <div style={{ color: "#354764" }} className={Styles.descTwo}>
                    Total Upfront Charges
                  </div>
                  <div
                    style={{ fontWeight: "bolder", color: "#003883" }}
                    className={Styles.descTwo}
                  >
                    {formatAmount(vehicleData?.TotalCharges)}
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                paddingLeft: "2em",
                paddingRight: "2em",
                paddingBottom: "1em",
              }}
            >
              <button
                disabled={vehicleData?.InspectionStatus !== "Completed"}
                style={{
                  background:
                    vehicleData?.InspectionStatus !== "Completed"
                      ? "#DFE0E4"
                      : "",
                  cursor:
                    vehicleData?.InspectionStatus !== "Completed"
                      ? "no-drop"
                      : "",
                }}
                onClick={props.openTerms}
                className={Styles.btn}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default MerchantConfirmationVehicleModal;
